import __request__ from "routing/request";
export function node(requestOptions) {
  return __request__("GET", "/system/cluster/node", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function nodes(requestOptions) {
  return __request__("GET", "/system/cluster/nodes", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function nodesBypageAndper_pageAndqueryAndsortAndorder(sort = "hostname", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/system/cluster/nodes/paginated", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function nodeBynodeId(nodeId, requestOptions) {
  return __request__("GET", `/system/cluster/nodes/${nodeId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
